'use client';

import React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from '../../../commons/helpers';
import ResultsHeader from './components/ResultsHeader';

/**
 * ResultsByCategory component for Next version (v7)
 * Uses Index widgets with useHits hook for multi-index search
 */
const ResultsByCategoryNext = ({ toggleSearchOpen, variant = 'desktop' }) => {
  const { results } = useInstantSearch();
  const query = results?.query || '';
  const currentPage = useUserCurrentPageType();

  if (!query || !results) {
    return null;
  }

  return (
    <>
      <ResultsHeader variant={variant}>View results by:</ResultsHeader>
      {/* Products count from main index */}
      {results.nbHits > 0 && (
        <Link
          to={getAdvancedSearchUrlForQueryAndIndex(query, 'products')}
          onClick={async () => {
            await toggleSearchOpen();
            avo.productsSearched({
              query,
              location: currentPage,
              searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK,
            });
          }}
          className={classNames(
            'text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8',
            {
              'block mr-2.5 text-[#585858]': variant === 'desktop',
            }
          )}
        >
          Products ({results.nbHits})
        </Link>
      )}
    </>
  );
};

ResultsByCategoryNext.propTypes = {
  toggleSearchOpen: PropTypes.func,
  variant: PropTypes.string,
};

export default ResultsByCategoryNext;
